import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import _, { cloneDeep } from "lodash"
import useStyles from "./styles"
import * as Adm from "@adm"
import MaterialDataGrid from "../../../../components/MaterialDataGrid"
import TableFilter from "../../../../components/tableFilter"
import api from "../../../../services/masterData/locations/api"
import { CloseRounded } from "@material-ui/icons"
import RefreshSharpIcon from "@material-ui/icons/RefreshSharp"

import {
  Button,
  Divider,
  AppBar,
  Tabs,
  Tab,
  IconButton,
  Tooltip,
  Card,
  Grid,
  Typography,
  TextField,
} from "@material-ui/core"
import update from "immutability-helper"
import classnames from "classnames"
import { Trash2, SearchIcon, InfoIconKit } from "@iconsGallery"
import * as IconsGallery from "@iconsGallery"
import { ConfirmationDialog } from "@features"
import styled from "styled-components"
import AttributeLookUpTable from "../../products/ProductDetailedPage/productAttribute/AttributeLookUpTable"
import AttributeTypeCheck from "../../products/ProductDetailedPage/productAttribute/AttributeTypeCheck"
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline"
import { productDataApiMethods } from "../../../../services/masterData/products/api"
import { useHistory } from "react-router-dom"
import { JSUtils } from "@utils"
let isTestLocal = true
const getAddonMock = (rowData) => {
  let lcRow = rowData

  // if (isTestLocal) {
  //   if (!_.isEmpty(lcRow?.docs)) {
  //     lcRow.docs = lcRow.docs.map((itm) => {
  //       const testObj = {
  //         offer_title: itm?.title || "",
  //         offer_image_url:
  //           "https://www.asiamarket.ie/media/catalog/product/cache/1ae38c744b0a21fab02034b60751c21a/c/o/coca-cola_icon_330ml_can_ean__5449000000996_5449000000996_1.png",
  //         offer_expires: "Expires 4 days",
  //         start_date: itm?.updatedAt || "",
  //         end_date: itm?.updatedAt || "",
  //         is_active: itm?.isActive || "",
  //       }
  //       return { ...testObj, ...itm }
  //     })
  //   }
  // }

  return lcRow
}
export const renderOnEdit = (
  props,
  {
    history,
    reDirectPath = "",
    editVariable = "",
    tableGlobalState = {},
    isType = "",
    isCustomFunc = false,
  }
) => {
  const { rowData = {}, setRowData = () => {} } = tableGlobalState || {}
  const newRowDataState = {
    ...rowData,
  }

  newRowDataState["editID"] = props.dataItem._id
  setRowData(newRowDataState)
  let urlPush = ""
  if (isType === "singel") {
    const preDefinedId = props.dataItem[editVariable] || ""
    urlPush = reDirectPath + encodeURIComponent(preDefinedId)
  }
  if (isType === "group") {
    let addUrl = ""
    const splitReDirectPath = reDirectPath.split("/")
    splitReDirectPath.forEach((item) => {
      if (item !== "") {
        let setItem = ""
        if (item.includes("=")) {
          const splitEqual = item.split("=")
          setItem = `${splitEqual[0]}=${props.dataItem[splitEqual[1]]}`
        } else {
          setItem = item
        }
        addUrl = addUrl + "/" + setItem
      }
    })
    urlPush = addUrl
  }
  urlPush !== "" && history.push(urlPush)
}
const TemplateTableHeaderGrid = styled(Grid)`
  .ecom-card-table-header {
    border-bottom: none;
    border-radius: 5px 5px 0 0 !important;
  }
`
const PageHeaderBreadcrumbKit = styled(Grid)`
  button {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-left: 18px;
    padding-right: 18px;
    max-width: unset;
  }
  margin-bottom: 24px;
  border-bottom: 1px #e0e0e0 solid;
  padding-bottom: 15px;
`
const SearchBox = styled(TextField)(() => ({
  "& fieldset": {
    borderRadius: "4px 0px 0px 4px",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--primaryColor)",
  },
}))
export const StyledSyncedButton = styled(Button)`
  margin: 0px 8px;
  background: #e0e0e0;
  min-width: 118px;
  height: 36px;
  color: black;
  font-weight: bold;
  @media (min-width: 1000px) and (max-width: 1200px) {
    min-width: 50px;
  }
  @media (min-width: 350px) and (max-width: 851px) {
    min-width: 30px;
  }
  @keyframes spin {
    100% {
      transform: rotate(-360deg);
    }
  }
  &.cls-syncing {
    svg {
      animation: spin 4s linear infinite;
    }
  }
  &:active {
    color: #fff;
    background: #53be57;
  }
  &:hover {
    color: #fff;
    background: #53be57;
  }
  svg {
    margin-right: 8px;
  }
`
const columnData = [
  {
    field: "locationName",
    title: "Location Name",
    editable: false,
    editor: "text",
    border: true,
    filter: true,
    show: true,
  },
  {
    field: "locationAddress.line1",
    title: "Location Address",
    editable: false,
    editor: "text",
    border: true,
    filter: true,
    show: true,
  },
  {
    field: "locationType.name",
    title: "Location Type",
    editable: false,
    editor: "text",
    border: true,
    filter: true,
    show: true,
  },
]

const defaultDataState = {
  filter: {
    logic: "and",
    filters: [],
  },
  sort: [],
  take: 50,
  skip: 0,
}

const defaultBodyData = {
  page: 1,
  limit: 10,
  sort: {},
  filter: {},
}

const renderUpdateTableFilterData = (item, stateProps) => {
  const { columnData, setColumnData } = stateProps || {}
  const newColumnData = [...columnData]
  newColumnData.map((val) => {
    if (val.field === item.field) {
      val.show = !val.show
    }
    return {}
  })
  setColumnData(newColumnData)
}

const deepCopy = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

const Table = ({
  isLiveEnable = false,
  getPathWSS = "",
  getLiveSocketPayload = null,
  getWsApiInfo = null,
  isCustomFilter = false,
  customFilterKit = {},
  setPreFillData = () => "",
  deleteDisabled = () => false,
  deleteTooltip = () => "Delete",
  editTooltip = () => "Edit",
  lcStorageData = "",
  getSelectRowItem = "",
  onUpdateSelectRowItem = () => "",
  staticItemData = {},
  isDisableForceNoActionMenu = false,
  isGridType = "",
  isGrid = false,
  isWriteAllowed,
  isDeleteAllowed,
  dataFetchMethod = () => {},
  deleteAnId = () => {},
  deleteMultipleId = () => {},
  deleteMultiple=false,
  isPageView = false,
  lookupType = "",
  noShowPrimaryWithoutSelect = false,
  columns = columnData,
  additionalButtons = [],
  customEditFunc = false,
  handleCustomFunc = () => {},
  onDiscard = () => {},
  onSave = () => {},
  onDelete = () => {},
  onDeleteDisabled = () => {},
  onView = () => {},
  onEdit = () => {},
  onItemChange = () => {},
  switchHandler = () => {},
  handleSingleDropdownChange = () => {},
  responseDataPath = "data.data",
  isLookUp = false,
  onPrimaryActionClick = () => {},
  handleClose = () => {},
  preSelectedItems = [],
  triggerDataFetch = { uncategorized: false, categorized: false },
  setAnyChanges = () => {},
  setTriggerDataFetch = () => {},
  dataFetchTriggerKey = "uncategorized",
  title = "UnCategorized Locations",
  selectedHierarchyIds = [],
  tableLocationAttributes = {},
  fetchOnlyOnSelectedIdUpdate = false,
  dataUniqueIdPath = "_id",
  primaryActionLabel = "Associate",
  showSearchBar,
  setExportGridData = () => {},
  isTablet,
  isMobile,
  customHeaderDisplay = () => {},
  renderAdditional = () => "",
  renderRightAdditional = () => "",
  additionalFilters = [
    { field: "locationHierarchy", operator: "eq", value: "" },
  ],
  tableFilter = true,
  clearFilterButton = false,
  ShowCheckBox = true,
  isStatic = false,
  set_reRender = "",
  setIsSynced = "",
  reRender = false,
  menutype = "master",
  pageable = true,
  displayAssociate = true,
  methodType = "",
  historyDetails = () => {},
  isCreating = false,
  addRow = {},
  isDisableViewIcon = false,
  isDirectClick = false,
  actionMenu = true,
  anyChanges = false,
  searchTerm = "",
  historyPopup = true,
  deleteIcon = false,
  actionDelete = true,
  nonApiDatastate = false,
  customPayload = false,
  onClickShekelSync = () => {},
  displayShekelSync = false,
  gridPayload = {},
  gridStateMaintain = false,
  reset = false,
  tableHeader = true,
  timeToolTip = false,
  customFilter = [],
  isMessageType = "1",
  deleteMessageContent = "",
  fileId = "",
  isBulkUploadLog = false,
  preselectedItemClearFilter = false,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  let history = useHistory()
  const { location = {} } = window || {}
  const fetchMethod = _.isFunction(dataFetchMethod)
    ? dataFetchMethod
    : api.getAllLocations
  const [columnData, setColumnData] = useState(columns)
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)
  const [reDirect, setReDirect] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isdelete, setIsdelete] = useState(false)

  let lcStorageDataKit = {}
  if (!_.isEmpty(lcStorageData)) {
    if (!_.isEmpty(localStorage.getItem(lcStorageData))) {
      lcStorageDataKit = JSON.parse(localStorage.getItem(lcStorageData))
      lcStorageDataKit = _.isEmpty(lcStorageDataKit)
        ? {
            dataState: deepCopy(defaultDataState),
          }
        : lcStorageDataKit
    } else {
      if (!_.isEmpty(lcStorageData)) {
        lcStorageDataKit = _.isEmpty(lcStorageDataKit)
          ? {
              dataState: deepCopy(defaultDataState),
            }
          : lcStorageDataKit
      }
    }
  }

  let defaultGridState = _.isEmpty(lcStorageData)
    ? {
        dataState: !_.isEmpty(gridPayload)
          ? gridPayload
          : deepCopy(defaultDataState),
      }
    : lcStorageDataKit
  const [gridState, setGridState] = useState(defaultGridState)
  const [selectedItems, setSelectedItems] = useState(
    () => preSelectedItems || []
  )

  const [gridData, setGridData] = useState({ data: [] })
  const [rawData, setRawData] = useState({})
  const [attSearchVal, setAttSearchVal] = useState("")
  const [isShekelSync, setIsShekelSync] = useState(false)
  const [getIsConnected, setIsConnected] = useState(false)

  const socketRef = React.useRef()
  const isMountedRef = React.useRef(true)
  const reconnectTimerRef = React.useRef(null)
  const lastWsPropsRef = React.useRef(null)

  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
      if (reconnectTimerRef.current) {
        clearTimeout(reconnectTimerRef.current)
        reconnectTimerRef.current = null
      }
      JSUtils.doCloseGlobalSocketControl(socketRef)
    }
  }, [])

  const doFetchWebSocket = (innerProps) => {
    if (isLiveEnable === false) {
      return
    }

    const { payload = {} } = innerProps || {}
    const { filter = {} } = payload || {}
    let filterKit = filter || payload
    const apiInfoPayLoad =
      typeof getWsApiInfo === "function"
        ? getWsApiInfo(innerProps)
        : {
            filter: {
              ...filterKit,
            },
          }
    if (
      !apiInfoPayLoad ||
      (typeof apiInfoPayLoad === "object" &&
        Object.keys(apiInfoPayLoad).length === 0)
    ) {
      return
    }

    lastWsPropsRef.current = innerProps
    if (reconnectTimerRef.current) {
      clearTimeout(reconnectTimerRef.current)
      reconnectTimerRef.current = null
    }

    JSUtils.doTriggerGlobalSocketControl({
      path: getPathWSS,
      apiInfo: apiInfoPayLoad,
      defaultSocketRef: socketRef,
      setDefaultIsConnected: setIsConnected,
      onUpdateMessage: (response) => {
        if (response?.error) {
          return
        }
        if (isMountedRef.current === false) {
          return
        }
        if (customPayload && isLiveEnable) {
          console.log("Transaction WS message:", new Date().toISOString())
        }
        if (customPayload) {
          const source = Array.isArray(response?.records)
            ? response
            : Array.isArray(response?.data?.records)
            ? response.data
            : response?.data || response || {}
          if (
            source?.records === undefined &&
            source?.total_records === undefined
          ) {
            return
          }
          const customPayloadCalls = {
            docs: source?.records || [],
            totalDocs: source?.total_records || 0,
            limit: source?.no_of_records_per_page || 0,
            page: source?.page_no || 0,
            totalPages: source?.total_no_of_pages || 0,
            pagingCounter: source?.page_first_record_seq_no || 0,
            hasPrevPage: source?.has_prev_page || false,
            hasNextPage: source?.has_next_page || source?.hasNextPage || false,
            prevPage: source?.prev_page_no || null,
            nextPage: source?.next_page_no || null,
          }
          setRawData(getAddonMock(customPayloadCalls))
          return
        }
        let resp = { data: { data: response?.data } }
        setPreFillData({
          ...resp,
          filterTemplateData: payload,
        })
        let bothApiCalls
        bothApiCalls = _.get(resp, responseDataPath)

        if (isCustomFilter) {
          bothApiCalls = {
            ...bothApiCalls,
            docs: bothApiCalls?.products || [],
            totalDocs: bothApiCalls?.pagination?.total || 0,
            limit: bothApiCalls?.pagination?.limit || 0,
            page: bothApiCalls?.pagination?.page || 0,
            totalPages: bothApiCalls?.pagination?.totalPages || 0,
          }
        }

        var customPayloadCalls = {}
        if (customPayload) {
          customPayloadCalls = {
            docs: bothApiCalls?.records || [],
            totalDocs: bothApiCalls?.total_records || 0,
            limit: bothApiCalls?.no_of_records_per_page || 0,
            page: bothApiCalls?.page_no || 0,
            totalPages: bothApiCalls?.total_no_of_pages || 0,
            pagingCounter: bothApiCalls?.page_first_record_seq_no || 0,
            hasPrevPage: bothApiCalls?.has_prev_page || false,
            hasNextPage: bothApiCalls?.hasNextPage || false,
            prevPage: bothApiCalls?.prev_page_no || null,
            nextPage: bothApiCalls?.next_page_no || null,
          }
        }
        setRawData(
          getAddonMock(customPayload ? customPayloadCalls : bothApiCalls)
        )
      },
      onError: () => "",
      onClose: () => {
        if (!isMountedRef.current || isLiveEnable === false) {
          return
        }
        reconnectTimerRef.current = setTimeout(() => {
          if (!isMountedRef.current || isLiveEnable === false) {
            return
          }
          doFetchWebSocket(lastWsPropsRef.current || innerProps)
        }, 3000)
      },
    })
  }
  const filtersViewNew = (dataState, page, limit, additionalFilters = []) => {
    console.log("LOAD...", dataState, page, limit, (additionalFilters = []))

    if (isCustomFilter) {
      const isSearch = isLookUp || searchTerm !== ""

      const sort = dataState.sort.reduce((acc, o) => {
        acc[o.field] = o.dir === "asc" ? 1 : -1
        return acc
      }, {})

      const filters = [...(dataState?.filter?.filters || [])]

      console.log("filters", filters)

      return {
        filter: {
          ...customFilterKit,
          tenantId: localStorage.getItem("sourceRole")?.includes("SaaS")
            ? localStorage.getItem("selectedDefaultTenantId")
            : localStorage.getItem("tenantId"),
          filters,
          sort,
          page,
          limit,
        },
      }
    } else {
      let sort = {}
      if (isLookUp) {
        sort = dataState.sort.reduce((acc, o) => {
          acc[o.field] = o.dir
          return acc
        }, {})
        return {
          page,
          limit,
          filter: [
            ...(dataState?.filter?.filters || []),
            ...(additionalFilters || []),
          ],
          sort,
          searchTerm: attSearchVal,
        }
      } else if (isBulkUploadLog) {
        let returnObj = {
          page,
          limit,
          filter: [],
          sort: {},
          tenant_id: localStorage.getItem("sourceRole")?.includes("SaaS")
            ? localStorage.getItem("selectedDefaultTenantId")
            : localStorage.getItem("tenantId"),
          file_Id: fileId,
        }
        return returnObj
      } else if (searchTerm !== "") {
        sort = dataState.sort.reduce((acc, o) => {
          acc[o.field] = o.dir
          return acc
        }, {})
        return {
          page,
          limit,
          filter: [
            ...(dataState?.filter?.filters || []),
            ...(additionalFilters || []),
          ],
          sort,
          searchTerm: searchTerm,
        }
      } else {
        sort = dataState.sort.reduce((acc, o) => {
          acc[o.field] = o.dir === "asc" ? 1 : -1
          return acc
        }, {})
        return {
          page,
          limit,
          filter: [
            ...(dataState?.filter?.filters || []),
            ...(additionalFilters || []),
          ],
          sort,
        }
      }
    }
  }

  const filtersViewLegacy = (
    dataState,
    page,
    limit,
    additionalFilters = []
  ) => {
    let sort = {}
    if (isLookUp) {
      sort = dataState.sort.reduce((acc, o) => {
        acc[o.field] = o.dir
        return acc
      }, {})
      return {
        page,
        limit,
        filter: [
          ...(dataState?.filter?.filters || []),
          ...(additionalFilters || []),
        ],
        sort,
        searchTerm: attSearchVal,
      }
    } else if (isBulkUploadLog) {
      let returnObj = {
        page,
        limit,
        filter: [],
        sort: {},
        tenant_id: localStorage.getItem("sourceRole")?.includes("SaaS")
          ? localStorage.getItem("selectedDefaultTenantId")
          : localStorage.getItem("tenantId"),
        file_Id: fileId,
      }
      return returnObj
    } else if (searchTerm !== "") {
      sort = dataState.sort.reduce((acc, o) => {
        acc[o.field] = o.dir
        return acc
      }, {})
      return {
        page,
        limit,
        filter: [
          ...(dataState?.filter?.filters || []),
          ...(additionalFilters || []),
        ],
        sort,
        searchTerm: searchTerm,
      }
    } else {
      sort = dataState.sort.reduce((acc, o) => {
        acc[o.field] = o.dir === "asc" ? 1 : -1
        return acc
      }, {})
      return {
        page,
        limit,
        filter: [
          ...(dataState?.filter?.filters || []),
          ...(additionalFilters || []),
        ],
        sort,
      }
    }
  }

  const adopterFunction = isCustomFilter ? filtersViewNew : filtersViewLegacy

  const fetchDataObject = () => {
    setLoading(true)
    // debugger
    // debugger

    fetchMethod(
      adopterFunction(
        gridState.dataState,
        Math.floor(gridState.dataState.skip / gridState.dataState.take) + 1,
        gridState.dataState.take,
        additionalFilters
      )
    )
      .then((resp) => {
        setPreFillData(
          {
            ...resp,
            filterTemplateData: adopterFunction(
              gridState.dataState,
              Math.floor(gridState.dataState.skip / gridState.dataState.take) +
                1,
              gridState.dataState.take,
              additionalFilters
            ),
          } || {}
        )
        let bothApiCalls
        bothApiCalls = _.get(resp, responseDataPath)
        var customPayloadCalls = {}
        if (customPayload) {
          customPayloadCalls = {
            docs: bothApiCalls?.records || [],
            totalDocs: bothApiCalls?.total_records || 0,
            limit: bothApiCalls?.no_of_records_per_page || 0,
            page: bothApiCalls?.page_no || 0,
            totalPages: bothApiCalls?.total_no_of_pages || 0,
            pagingCounter: bothApiCalls?.page_first_record_seq_no || 0,
            hasPrevPage: bothApiCalls?.has_prev_page || false,
            hasNextPage: bothApiCalls?.hasNextPage || false,
            prevPage: bothApiCalls?.prev_page_no || null,
            nextPage: bothApiCalls?.next_page_no || null,
          }
        }
        setLoading(false)
        _.isFunction(set_reRender) && set_reRender(false)
        _.isFunction(setIsSynced) && setIsSynced(false)
        if (preselectedItemClearFilter) {
          handleClearSelection()
        }

        if (isCustomFilter) {
          bothApiCalls = {
            ...bothApiCalls,
            docs: bothApiCalls?.products || [],
            totalDocs: bothApiCalls?.pagination?.total || 0,
            limit: bothApiCalls?.pagination?.limit || 0,
            page: bothApiCalls?.pagination?.page || 0,
            totalPages: bothApiCalls?.pagination?.totalPages || 0,
            // pagingCounter: bothApiCalls?.page_first_record_seq_no || 0,
            // hasPrevPage: bothApiCalls?.has_prev_page || false,
            // hasNextPage: bothApiCalls?.hasNextPage || false,
            // prevPage: bothApiCalls?.prev_page_no || null,
            // nextPage: bothApiCalls?.next_page_no || null,
          }
        }
        setRawData(
          getAddonMock(customPayload ? customPayloadCalls : bothApiCalls)
        )
        setExportGridData({
          ...gridState.dataState,
          totalDocs: resp?.data?.data?.totalDocs,
        })
        doFetchWebSocket({
          payload: adopterFunction(
            gridState.dataState,
            Math.floor(gridState.dataState.skip / gridState.dataState.take) + 1,
            gridState.dataState.take,
            additionalFilters
          ),
        })
      })
      .catch((err) => {
        setPreFillData({})
        setLoading(false)
      })
  }

  useEffect(() => {
    const asyncFetchDatareRender = async () => {
      if (reRender && !isStatic) {
        fetchDataObject()
      } else if (reRender && isStatic && methodType === "post") {
        fetchDataObject()
      } else if (reRender && isStatic) {
        setLoading(true)
        // debugger
        const tempData = await fetchMethod(tableFilter)
        await setRawData(getAddonMock(_.get(tempData, responseDataPath)))
        // await setRawData(_.get(tempData, responseDataPath))
        await setLoading(false)
        await doFetchWebSocket({ payload: tableFilter })
      }
    }
    asyncFetchDatareRender()
  }, [reRender])

  useEffect(() => {
    const asyncFetchData = async () => {
      if (!isStatic && !reRender) {
        fetchDataObject()
      } else if (isStatic && methodType === "post" && !reRender) {
        fetchDataObject()
      } else if (isStatic && !reRender) {
        setLoading(true)
        // debugger
        const tempData = await fetchMethod(tableFilter)
        await setLoading(false)
        await setRawData(getAddonMock(_.get(tempData, responseDataPath)))
        await doFetchWebSocket({ payload: tableFilter })
      }
    }
    asyncFetchData()
  }, [gridState.dataState])

  useEffect(() => {
    setAttSearchVal(attSearchVal)
  }, [attSearchVal])
  useEffect(() => {
    if (!_.isEmpty(lcStorageData)) {
      localStorage.setItem(lcStorageData, JSON.stringify(gridState))
    }
  }, [gridState])

  useEffect(() => {
    if (!isStatic || (isStatic && methodType === "post")) {
      if (
        triggerDataFetch[dataFetchTriggerKey] ||
        fetchOnlyOnSelectedIdUpdate
      ) {
        // debugger
        fetchMethod(
          adopterFunction(
            gridState.dataState,
            Math.floor(gridState.dataState.skip / gridState.dataState.take) + 1,
            gridState.dataState.take,
            additionalFilters
          )
        )
          .then((resp) => {
            setRawData(getAddonMock(_.get(resp, responseDataPath)))
            setTriggerDataFetch((c) => ({ ...c, [dataFetchTriggerKey]: false }))
            _.isFunction(set_reRender) && set_reRender(false)
            doFetchWebSocket({
              payload: adopterFunction(
                gridState.dataState,
                Math.floor(
                  gridState.dataState.skip / gridState.dataState.take
                ) + 1,
                gridState.dataState.take,
                additionalFilters
              ),
            })
          })
          .catch((err) => {
            setLoading(false)
          })
      }
    }
  }, [triggerDataFetch[dataFetchTriggerKey], selectedHierarchyIds])

  useEffect(() => {
    if (!_.isEmpty(rawData)) {
      setGridData(() => {
        let x = _.cloneDeep(_.get(rawData, "docs", []))
        let data = x.reduce((acc, o, i) => {
          if (
            _.findIndex(
              selectedItems,
              (c) =>
                _.get(o, dataUniqueIdPath, "*_*") ===
                _.get(c, dataUniqueIdPath, "-_-")
            ) !== -1
          ) {
            o.selected = true
          }
          acc.push(o)
          return acc
        }, [])

        let dataKit = []

        if (!_.isEmpty(staticItemData)) {
          dataKit.push(staticItemData)
        }
        dataKit = [...dataKit, ...data]
        return { data: dataKit }
      })
    }
  }, [rawData])

  useEffect(() => {
    if (isCreating) {
      let tableData = anyChanges
        ? rawData?.docs
        : _.cloneDeep(gridData.data) || []
      tableData?.map((val) => {
        if (val._id !== "new") {
          val.inEdit = false
        }
        return val
      })
      setGridData({
        ...gridData,
        data: [addRow, ...tableData],
      })
    }
  }, [isCreating])

  useEffect(() => {
    let shekelStatus =
      selectedItems?.length > 10
        ? true
        : !_.isEmpty(
            _.filter(selectedItems, function (o) {
              return (
                o?.isShekelSync ||
                (!o?.isShekelSync && _.size(o?.item_images)) === 0
              )
            })
          )
    setIsShekelSync(shekelStatus)
  }, [selectedItems])

  useEffect(() => {
    const { dataState = {} } = gridState || {}
    const { filter = {} } = dataState || {}
    const { filters = [] } = filter || {}

    const { sort = [] } = dataState

    const { skip = 0 } = dataState

    let isFilterAvailable = filters.length > 0
    let issortAvailable = sort?.length > 0
    let isSkipAvailable = skip > 0

    let isFilter =
      gridStateMaintain &&
      (isFilterAvailable || issortAvailable || isSkipAvailable)

    history.push(`${location.pathname}?filter=${isFilter}`)
    gridStateMaintain &&
      localStorage.setItem(
        location.pathname.replaceAll("/", "_"),
        JSON.stringify({
          filter: isFilter,
          dataState: gridState?.dataState,
        })
      )
  }, [gridState])

  const resetMethod = () => {
    setGridState({ dataState: deepCopy(defaultDataState) })
  }

  const handleSelection = (e) => {
    let temp = []
    let tempGridData = {}
    let dataItem = e.dataItem
    let existingIdx = _.findIndex(
      selectedItems,
      (o, id) =>
        _.get(o, dataUniqueIdPath, "*_*") ===
        _.get(dataItem, dataUniqueIdPath, "-_-")
    )
    let idxInDataState = _.findIndex(
      gridData.data,
      (o) =>
        _.get(o, dataUniqueIdPath, "*_*") ===
        _.get(dataItem, dataUniqueIdPath, "-_-")
    )
    if (existingIdx === -1) {
      temp = update(selectedItems, { $push: [dataItem] })
      tempGridData = update(gridData, {
        data: { [idxInDataState]: { $merge: { selected: true } } },
        allSelected: { $set: false },
      })
    } else {
      temp = update(selectedItems, { $splice: [[existingIdx, 1]] })
      tempGridData = update(gridData, {
        data: { [idxInDataState]: { $merge: { selected: false } } },
        allSelected: { $set: false },
      })
    }
    setSelectedItems(temp)
    setGridData(tempGridData)
  }

  const deleteItems = async (selectedItems) => {
    await deleteMultipleId(selectedItems)
    await setSelectedItems([])
    await fetchDataObject()
  }

  const handleClearSelection = () => {
    setSelectedItems([])
    setGridData((c) => {
      return {
        data: c.data.map((x) => {
          x.selected = false
          return x
        }),
      }
    })
  }
  const onHeaderSelectionChange = React.useCallback((event) => {
    const checkboxElement = event.syntheticEvent.target
    const checked = checkboxElement.checked
    if (checked) {
      setGridData((c) => {
        let data = _.map(c?.data || [], (o, i) => {
          o.selected = true
          return o
        })
        setSelectedItems((s) => {
          let temp = _.isEmpty(s) ? [] : _.cloneDeep(s)
          return _.uniqBy([...temp, ...data], dataUniqueIdPath)
        })
        return {
          allSelected: true,
          data,
        }
      })
    } else {
      setGridData((c) => {
        let data = c.data.map((x) => {
          x.selected = false
          return x
        })

        setSelectedItems((s) => {
          let filteredSelection = _.differenceBy(s, data, dataUniqueIdPath)
          return filteredSelection
        })
        return {
          data,
        }
      })
    }
  }, [])
  const handleCustomCloseRedirect = () => {
    setOpenConfirmationDialog(false)
    deleteItems(selectedItems)
  }

  const handleCloseButtonTrigger = () => {
    handleClearSelection()
  }

  const isMobileVeiw = window.innerWidth <= 580

  return (
    <>
      <Adm.BackdropOverlay open={loading} />

      <ConfirmationDialog
        openConfirmationDialog={openConfirmationDialog}
        setOpenConfirmationDialog={setOpenConfirmationDialog}
        setReDirect={setReDirect}
        handleCloseButtonTrigger={handleCloseButtonTrigger}
        handleCustomCloseRedirect={handleCustomCloseRedirect}
        deleteContent={
          deleteMessageContent
            ? deleteMessageContent
            : isMessageType === "2"
            ? `Are you sure you want to delete this ${title.slice(
                0,
                -1
              )}(s)? This action cannot be undone.`
            : `Selected ${title.slice(
                0,
                -1
              )}(s) would be archived, do you really want to continue ?`
        }
      />

      <div className={classes.container}>
        {tableHeader && (
          <div
            className={classnames(classes.header, {
              [classes.noPadding]: isPageView,
              [classes.height60]: isPageView,
            })}
          >
            <TemplateTableHeaderGrid item lg={12} md={12} sm={12} xs={12}>
              <Card className="ecom-card-table-header">
                <Grid
                  container
                  item
                  row="true"
                  justify="space-between"
                  alignContent="center"
                  style={{
                    paddingLeft: "16px",
                    height: isMobileVeiw ? "initial" : "60px",
                    flexDirection: isMobileVeiw ? "column" : "row",
                    flexWrap: "nowrap",
                    alignItems: isMobileVeiw ? "flex-start" : "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "50px",
                      flexDirection: isMobileVeiw ? "column" : "row",
                      padding: isMobileVeiw ? "15px 0 15px 0" : "0",
                    }}
                  >
                    <div>
                      <Typography
                        variant="h4"
                        className={classnames(classes.title, {
                          [classes.headerTitle]: isPageView,
                        })}
                      >
                        {title}
                      </Typography>
                    </div>
                    {/* <div>
                      {timeToolTip && (
                        <Tooltip
                          title="Offer start and end dates follow Eastern Time (ET), regardless of the user’s local time zone"
                          placement="top"
                        >
                          <Typography
                            variant="h4"
                            className={classnames(classes.title, {
                              [classes.headerTitle]: isPageView,
                            })}
                          >
                            <span style={{ fontSize: 14 }}>
                              {`Eastern Time (ET)`}
                            </span>
                          </Typography>
                        </Tooltip>
                      )}
                    </div> */}
                    {renderAdditional()}
                  </div>
                  {showSearchBar && (
                    <span style={{ display: "flex", width: "15vw" }}>
                      <SearchBox
                        size="small"
                        fullWidth
                        value={attSearchVal}
                        placeholder="Search"
                        variant="outlined"
                        onChange={(e) => {
                          setAttSearchVal(e.target.value)
                        }}
                      />

                      <IconButton
                        style={{
                          backgroundColor: "var(--primaryColor)",
                          borderRadius: "0px 4px 4px 0px",
                          width: "36px",
                          height: "37.5px",
                        }}
                        size="small"
                        variant="outlined"
                        onClick={() => fetchDataObject()}
                      >
                        <SearchIcon style={{ color: "white" }} />
                      </IconButton>
                    </span>
                  )}
                  {(selectedItems.length > 0 ||
                    gridData?.allSelected ||
                    isLookUp ||
                    (_.isArray(additionalButtons) &&
                      !_.isEmpty(additionalButtons))) && (
                    <HeaderActionsContainer
                      columnData={columnData}
                      setColumnData={setColumnData}
                      noShowPrimaryWithoutSelect={noShowPrimaryWithoutSelect}
                      additionalButtons={additionalButtons}
                      isLookUp={isLookUp}
                      onPrimaryActionClick={() =>
                        onPrimaryActionClick(
                          selectedItems,
                          handleClearSelection
                        )
                      }
                      count={
                        selectedItems.length > 0
                          ? selectedItems.length
                          : gridData?.allSelected
                          ? gridData?.data?.length
                          : selectedItems.length
                      }
                      classes={classes}
                      label={primaryActionLabel}
                      handleClearSelection={handleClearSelection}
                      showSearchBar={showSearchBar}
                      setAnyChanges={setAnyChanges}
                      deleteItems={() => deleteItems(selectedItems)}
                      setOpenConfirmationDialog={setOpenConfirmationDialog}
                      lookupType={lookupType}
                      displayAssociate={displayAssociate}
                      selectedItems={selectedItems}
                      isShekelSync={isShekelSync}
                      loading={loading}
                      onClickShekelSync={onClickShekelSync}
                      displayShekelSync={displayShekelSync}
                      isDeleteAllowed={isDeleteAllowed}
                      isWriteAllowed={isWriteAllowed}
                    />
                  )}
                  <span>
                    {displayAssociate && (
                      <>
                        {isLookUp ? (
                          <Tooltip title="Close" placement="top">
                            <CloseRounded
                              style={{
                                width: "25px",
                                margin: "30px",
                                height: "30px",
                                marginTop: "30px",
                                color: "gray",
                              }}
                              onClick={handleClose}
                            />
                          </Tooltip>
                        ) : null}
                      </>
                    )}
                  </span>
                  {selectedItems?.length > 0 && clearFilterButton && (
                    <div
                      style={{ padding: isMobileVeiw ? "20px 0 0 0" : "20px" }}
                    >
                      <Button
                        variant="text"
                        style={{
                          border: "1px solid #af2b99",
                          padding: "0px 20px 0px 20px",
                          fontWeight: "bold",
                          height: "35px",
                          marginRight: "10px",
                          color: "#af2b99",
                        }}
                        onClick={handleClearSelection}
                        startIcon={<RefreshSharpIcon />}
                      >
                        {`Clear Filter`}
                      </Button>
                    </div>
                  )}
                  {tableFilter && (
                    <div
                      style={{
                        padding: isMobileVeiw ? "0 0 20px 0 " : "20px",
                        flexDirection: "row",
                        display: "flex",
                      }}
                    >
                      {renderRightAdditional()}
                      <TableFilter
                        tableFilterData={columnData}
                        updateTableFilterData={(item) =>
                          renderUpdateTableFilterData(item, {
                            columnData,
                            setColumnData,
                          })
                        }
                        reset={reset}
                        resetFilterMethod={() => {
                          resetMethod()
                        }}
                      />
                      {_.isArray(additionalButtons) &&
                      !_.isEmpty(additionalButtons)
                        ? additionalButtons
                        : null}
                    </div>
                  )}
                </Grid>
              </Card>
            </TemplateTableHeaderGrid>
          </div>
        )}

        <div className={classes.content}>
          <MaterialDataGrid
            onUpdateSelectRowItem={onUpdateSelectRowItem}
            getSelectRowItem={getSelectRowItem}
            isDisableForceNoActionMenu={isDisableForceNoActionMenu}
            isDirectClick={isDirectClick}
            isGrid={isGrid}
            isGridType={isGridType}
            isDisableViewIcon={isDisableViewIcon}
            isInlineDeleteAllowed={isDeleteAllowed}
            isInlineEditAllowed={isWriteAllowed}
            columnData={columnData}
            gridState={gridState}
            setGridState={setGridState}
            rowData={gridData}
            setRowData={setGridData}
            deleteMultiple={deleteMultiple}
            isLookup={isLookUp || !isPageView}
            number_of_items={_.toFinite(rawData?.totalDocs || 0)}
            selectionChange={(event) => handleSelection(event)}
            otherProps={{ style: { height: "100%" } }}
            headerSelectionChange={(e) => onHeaderSelectionChange(e)}
            deleteIcon={deleteIcon}
            deleteIconHolder={<DeleteOutlineIcon />}
            tooltipColors={{
              view: true,
              history: true,
              delete: true,
            }}
            deleteDisabled={deleteDisabled}
            deleteTooltip={deleteTooltip}
            editTooltip={editTooltip}
            actionMenu={actionMenu}
            onEdit={(props) => {
              customEditFunc
                ? handleCustomFunc({ ...props, gridData, setGridData })
                : renderOnEdit(props, tableLocationAttributes)
            }}
            onDiscard={(props) => {
              onDiscard({ ...props, gridData, setGridData })
            }}
            switchHandler={(event, props) => {
              switchHandler({ ...props, gridData, setGridData })
            }}
            onSave={(props) => {
              onSave({ ...props, gridData, setGridData })
            }}
            onDelete={(props) => {
              onDelete({ ...props, gridData, setGridData })
            }}
            onDeleteDisabled={(data) => {
              onDeleteDisabled(data)
            }}
            onView={(props) => {
              onView({ ...props, gridData, setGridData })
            }}
            itemChange={(e) => onItemChange(e, { gridData, setGridData })}
            handleSingleDropdownChange={(e, props) =>
              handleSingleDropdownChange(e, { gridData, setGridData, ...props })
            }
            menutype={menutype}
            tableFilter={tableFilter}
            ShowCheckBox={deleteMultiple??ShowCheckBox}
            pageable={pageable}
            historyPopup={historyPopup}
            actionDelete={actionDelete}
            nonApiDatastate={nonApiDatastate}
            customFilter={customFilter || []}
          />
        </div>
      </div>
    </>
  )
}

const HeaderActionsContainer = ({
  showSearchBar,
  onPrimaryActionClick = () => {},
  setAnyChanges = () => {},
  setOpenConfirmationDialog = () => {},
  columnData = [],
  setColumnData = () => {},
  noShowPrimaryWithoutSelect = false,
  additionalButtons = [],
  classes = {},
  count = 0,
  label = "Primary Action",
  isLookUp = false,
  handleClearSelection = () => {},
  deleteItems = () => {},
  lookupType = "",
  isMobile,
  displayAssociate = true,
  selectedItems = [],
  isShekelSync = false,
  loading = false,
  onClickShekelSync = () => {},
  displayShekelSync = false,
  isDeleteAllowed = true,
  isWriteAllowed = false,
}) => {
  return (
    <>
      <div className={classes.headerActionsContainer}>
        {displayShekelSync && (
          <>
            <Tooltip title="Refresh" placement="top">
              <StyledSyncedButton
                className={`${loading ? "cls-syncing" : ""}`}
                onClick={() => {
                  if (!isWriteAllowed) return
                  onClickShekelSync(selectedItems)
                  handleClearSelection()
                }}
                disabled={isShekelSync || !isWriteAllowed}
              >
                <IconsGallery.LastSync />
                <span className={"cls-StyledSyncedButton-text"}>
                  {`Sync to Shekel`}
                </span>
              </StyledSyncedButton>
            </Tooltip>
            {isShekelSync && (
              <Tooltip
                title={`Ensure images are updated for all selected products. A maximum of 10 failed-to-sync products only can be selected`}
                placement="top"
              >
                <IconButton style={{ padding: 5 }}>
                  <InfoIconKit fill="#af2b99" />
                </IconButton>
              </Tooltip>
            )}
          </>
        )}
        {count > 0 ? (
          <Typography variant="h5" className={classes.subTitle}>
            {count} {count > 1 ? "" : " "}Selected
          </Typography>
        ) : null}

        {displayAssociate && (
          <>
            {isLookUp ? (
              <>
                <Button
                  onClick={() => {
                    setAnyChanges(true)
                    onPrimaryActionClick()
                  }}
                  variant="contained"
                  color="primary"
                  style={{ backgroundColor: "var(--primaryColor)" }}
                >
                  ASSOCIATE
                </Button>
                <Button
                  color="primary"
                  style={{ fontWeight: "bold", color: "var(--primaryColor)" }}
                  onClick={handleClearSelection}
                >
                  Clear
                </Button>
              </>
            ) : count > 0 && isDeleteAllowed ? (
              <>
                <Tooltip title="Archive" placement="top">
                  <IconButton onClick={() => setOpenConfirmationDialog(true)}>
                    <Trash2 />
                  </IconButton>
                </Tooltip>
              </>
            ) : null}
          </>
        )}
      </div>
    </>
  )
}

export default Table
